import { render } from "./TouchScreen.vue?vue&type=template&id=edf95fd6&scoped=true"
import script from "./TouchScreen.vue?vue&type=script&scoped=true&lang=js"
export * from "./TouchScreen.vue?vue&type=script&scoped=true&lang=js"

import "./TouchScreen.vue?vue&type=style&index=0&id=edf95fd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edf95fd6"]])

export default __exports__